module.exports = __webpack_public_path__ + "img/thumb-spaghetti-carbonara.4d4e82af.jpeg";